import { render, staticRenderFns } from "./mallClassify.vue?vue&type=template&id=5a22e072&scoped=true&"
import script from "./mallClassify.vue?vue&type=script&lang=js&"
export * from "./mallClassify.vue?vue&type=script&lang=js&"
import style0 from "./mallClassify.vue?vue&type=style&index=0&id=5a22e072&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a22e072",
  null
  
)

export default component.exports